/* eslint-disable camelcase -- uses palette names from design source */
import React, { useContext, useEffect, useState } from 'react';

import EventDetailView from '@totem/components/services/threats/detailView/EventDetailView';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { Event } from '@totem/types/events';
import { EVENTS_ENDPOINT } from '@totem/utilities/endpoints';
export interface Props {
  eventId: string;
}
const Ticket_Event = ({ eventId }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [event, setEvent] = useState<Event>(null);
  useEffect(() => {
    fetch(`${EVENTS_ENDPOINT}/${eventId}`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: Event) => {
        setEvent(result);
      });
  }, [eventId, getApiToken]);
  return <>{event !== null && <EventDetailView event={event} />}</>;
};
export default Ticket_Event;
